<template>
    <session-lock-modal 
        v-if="showNewPin"
        :show="showNewPin"
        @cancel="showNewPin = false"
        @confirm="toClipboard()"
        title="Account Pin"
        content="This is an auto-generated PIN"
        action-text="Copy"
        cancel-text="Close"
        :pinCode="newPinCode"
        :validate="false"
        hasPinCode
        whiteBg
    />

    <page-loader :show="loading"/>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import SessionLockModal from '@/components/modals/SessionLockModal.vue';

import PinCodeProcessor from '@/helpers/hashPin'

import Storage from "@/helpers/storage";

import PageLoader from "@/components/loaders/PageLoader.vue"

const storage = new Storage();

const showNewPin = ref<boolean>(false);
const loading = ref<boolean>(false);
const newPinCode = ref<string>('');

const hasPinCode = (): void => {
    if (PinCodeProcessor.noPinCode()) {
        loading.value = true
        newPinCode.value = getRandomInt(100000, 999999).toString();

        PinCodeProcessor.setPin(newPinCode.value).then(() => {
            showNewPin.value = true;
            loading.value = false
        }).catch((error: any) => { console.log(error) });
    }
}

const getRandomInt = (min: number, max: number): number => {
    // find diff
    const difference = max - min;

    // generate random number 
    let rand = Math.random();

    // multiply with difference 
    rand = Math.floor(rand * difference);

    // add with min value 
    rand = rand + min;

    return rand;
}

const toClipboard = async () => {
    await navigator.clipboard.writeText(newPinCode.value).then(() => {
        showNewPin.value = false
    });
};

onMounted(() => {
    if (!storage.get('isSessionLock')) {
        hasPinCode();
    }
})
</script>